module.exports = __webpack_public_path__ + "media/notosans/SubNotoSansJP_regular-eaeb96a7.woff";